"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const rotatebrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 63 72",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-rotatebrand01` : '') + (description ? ` desc-rotatebrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-rotatebrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-rotatebrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.364 72C50.178 72 63 59.106 63 43.2S50.179 14.4 34.364 14.4c-15.816 0-28.637 12.894-28.637 28.8S18.548 72 34.364 72Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F26B1C"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.867.25a1 1 0 0 1 .004 1.415l-8.845 8.895 8.845 8.895a1 1 0 0 1-1.418 1.41l-9.546-9.6a1 1 0 0 1 0-1.41l9.546-9.6A1 1 0 0 1 32.867.25ZM1.318 35.963a1 1 0 0 1 .916 1.077 29.07 29.07 0 0 0-.095 2.32v.001c-.003 2.345.29 4.68.872 6.95a1 1 0 0 1-1.937.497 29.87 29.87 0 0 1-.935-7.449c0-.828.036-1.664.102-2.48a1 1 0 0 1 1.077-.916ZM.139 39.36l1 .001h-1ZM8.482 20.081a1 1 0 0 1 .125 1.409 27.715 27.715 0 0 0-3.774 5.887 1 1 0 0 1-1.807-.859 29.717 29.717 0 0 1 4.047-6.312 1 1 0 0 1 1.409-.125ZM7.267 57.193a1 1 0 0 1 1.409.122c.49.584 1.01 1.153 1.56 1.705a27.592 27.592 0 0 0 5.502 4.293 1 1 0 0 1-1.02 1.72 29.59 29.59 0 0 1-5.901-4.603 29.585 29.585 0 0 1-1.673-1.828 1 1 0 0 1 .123-1.41Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.616 10.56a1 1 0 0 1 1-1h7.16c16.372 0 29.636 13.347 29.636 29.8 0 16.453-13.264 29.8-29.637 29.8-.824 0-1.656-.036-2.467-.102a1 1 0 1 1 .162-1.994c.761.062 1.539.096 2.305.096 15.258 0 27.637-12.441 27.637-27.8s-12.379-27.8-27.637-27.8h-7.159a1 1 0 0 1-1-1Z"
  })));
};
var _default = exports.default = rotatebrand01;